import { render, staticRenderFns } from "./left-menu-footer.vue?vue&type=template&id=406aa318&scoped=true"
import script from "./left-menu-footer.vue?vue&type=script&lang=js"
export * from "./left-menu-footer.vue?vue&type=script&lang=js"
import style0 from "./left-menu-footer.vue?vue&type=style&index=0&id=406aa318&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406aa318",
  null
  
)

export default component.exports